import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePermissionStore = defineStore('permission', () => {
    const locationPermissionEnabled = ref(localStorage.getItem('locationPermissionEnabled'));

    function enableLocationPermission() {
        locationPermissionEnabled.value = true;
        localStorage.setItem('locationPermissionEnabled', true);
    }
    function isLocationPermissionEnabled() {
        return locationPermissionEnabled.value;
    }

    return {
        locationPermissionEnabled,
        enableLocationPermission,
        isLocationPermissionEnabled
    };
});